export default "__VITE_ASSET__73243057__"